module.exports = __webpack_public_path__ + "img/service.d73feab3.png";